import styled from 'styled-components/macro';

export const InfoTile = styled.div`
  margin-top: 10px;
  border-left: solid 1px
    ${({ theme, borderColor }) =>
      borderColor ? theme[borderColor] : theme.dark};
  padding-left: 10px;
  color: ${({ theme, color }) => (color ? theme[color] : theme.dark)};
`;

export const Title = styled.p`
  line-height: 16px;
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.paragraph}px;
`;

export const Content = styled.p`
  line-height: 20px;
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.h5}px;
`;
